import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AuthLogin from './AuthLogin';
import { AuthProvider } from './AuthHooks';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<AuthProvider>
				<AuthLogin />
			</AuthProvider>
		</BrowserRouter>
	</React.StrictMode>
);